import { TaxabilityOption } from '../types';

const TAXABILITY_OPTIONS: TaxabilityOption[] = [
    { value: 1, label: "Taxable" },
    { value: 2, label: "Exempted" },
    { value: 3, label: "Non-Taxable" },
    { value: 4, label: "GST Reverse charge" },
    { value: 5, label: "Out Of Scope" },
];

export const getTaxabilityLabel = (value: number): string => {
    const option = TAXABILITY_OPTIONS.find(opt => opt.value === value);
    return option?.label || '';
};
